import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { ContentModuleSegment } from "./ContentArticle.styles";
import { renderContentModule } from "./contentModule";
export var ContentArticle = function(param) {
    var modules = param.modules, translations = param.translations;
    if (!modules || modules.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: modules.map(function(module, index) {
            var key = "".concat(module.moduleType, "-").concat(index);
            return /*#__PURE__*/ _jsx(ContentModuleSegment, {
                bottomMargin: module.bottomMargin || "default",
                children: renderContentModule(module, translations)
            }, key);
        })
    });
};
